import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const GovernanceProLayout = lazy(() =>
  import('../components/governance-pro/GovernanceProLayout').then((m) => ({ default: m.GovernanceProLayout }))
)
const GovProHubPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.HubPage }))
)
const GovProCockpitPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.CockpitPage }))
)
const GovProScorePage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.ScorePage }))
)
const GovProWizardPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.WizardPage }))
)
const GovProFrameworkPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.FrameworkPage }))
)
const GovProModelPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.ModelPage }))
)
const GovProOperatingModelPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.OperatingModelPage }))
)
const GovProRolesPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.RolesPage }))
)
const GovProPoliciesPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.PoliciesPage }))
)
const GovProProceduresPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.ProceduresPage }))
)
const GovProDirectivesPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.DirectivesPage }))
)
const GovProStandardsPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.StandardsPage }))
)
const GovProEncadrementPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.EncadrementPage }))
)
const GovProGRCDashboardPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.GRCDashboardPage }))
)
const GovProCompliancePage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.GovProCompliancePage }))
)
const GovProRiskRegisterPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.RiskRegisterPage }))
)
const GovProControlsAuditPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.ControlsAuditPage }))
)
const GovProAuthorityRegisterPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.AuthorityRegisterPage }))
)
const GovProAIImpactPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.AIImpactPage }))
)
const GovProStrategicAnalysisPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.StrategicAnalysisPage }))
)
const GovProMaturityBridgePage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.MaturityBridgePage }))
)
const GovProBenchmarkPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.BenchmarkPage }))
)
const GovProAlignmentPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.AlignmentPage }))
)
const GovProDataProgramPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.DataProgramPage }))
)
const GovProAIProgramPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.AIProgramPage }))
)
const GovProCloudProgramPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.CloudProgramPage }))
)
const GovProCulturePage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.CulturePage }))
)
const GovProRoadmapPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.GovProRoadmapPage }))
)
const GovProTargetsPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.TargetsPage }))
)
const GovProProcessesPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.ProcessesPage }))
)
const GovProOpsGovernancePage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.OpsGovernancePage }))
)
const GovProRiskProfilePage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.RiskProfilePage }))
)
const GovProReportsPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.GovProReportsPage }))
)
const GovProTemplatesPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.TemplatesPage }))
)
const GovProIntegrationPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.GovProIntegrationPage }))
)
const GovProAuditTrailPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.GovProAuditTrailPage }))
)
const GovProSettingsPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.GovProSettingsPage }))
)
const GovProOutilsPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.GovProOutilsPage }))
)
const GovProIssueRegistryPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.IssueRegistryPage }))
)
const GovProIssueDetailPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.IssueDetailPage }))
)
const GovProPolicyDetailPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.PolicyDetailPage }))
)
const GovProProcedureDetailPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.ProcedureDetailPage }))
)
const GovProStandardDetailPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.StandardDetailPage }))
)
const GovProRiskRegisterDetailPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.RiskRegisterDetailPage }))
)

// Wave21: Newly registered (previously orphaned) pages
const GovProBoardReportPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.BoardReportPage }))
)
const GovProBusinessContinuityPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.BusinessContinuityPage }))
)
const GovProContractLifecyclePage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.ContractLifecyclePage }))
)
const GovProExceptionManagementPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.ExceptionManagementPage }))
)
const GovProGrcExecutiveSummaryPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.GrcExecutiveSummaryPage }))
)
const GovProGrcReportingCenterPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.GrcReportingCenterPage }))
)
const GovProIntegratedRiskAggregatePage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.IntegratedRiskAggregatePage }))
)
const GovProIntegrationHubPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.IntegrationHubPage }))
)
const GovProIssueManagementPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.IssueManagementPage }))
)
const GovProPolicyExceptionPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.PolicyExceptionPage }))
)
const GovProPolicyLifecyclePage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.PolicyLifecyclePage }))
)
const GovProRegulatoryExamPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.RegulatoryExamPage }))
)
const GovProResiliencePage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.ResiliencePage }))
)
const GovProResilienceTestingPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.ResilienceTestingPage }))
)
const GovProStakeholderTaskPortalPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.StakeholderTaskPortalPage }))
)
const GovProUnifiedIncidentPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.UnifiedIncidentPage }))
)
const GovProWorkflowHubPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.WorkflowHubPage }))
)
const GovProObjectivesPage = lazy(() =>
  import('../pages/governance-pro').then((m) => ({ default: m.GovProObjectivesPage }))
)

export const governanceProRoutes: RouteObject[] = [
  {
    path: '/governance-pro',
    element: <GovernanceProLayout />,
    children: [
      { index: true, element: <GovProHubPage /> },

      { path: 'hub', element: <GovProHubPage /> },
      { path: 'cockpit', element: <GovProCockpitPage /> },
      { path: 'score', element: <GovProScorePage /> },
      { path: 'wizard', element: <GovProWizardPage /> },
      { path: 'framework', element: <GovProFrameworkPage /> },
      // Alias: docs / external links use plural "frameworks"
      { path: 'frameworks', element: <GovProFrameworkPage /> },
      { path: 'model', element: <GovProModelPage /> },
      { path: 'operating-model', element: <GovProOperatingModelPage /> },
      { path: 'roles', element: <GovProRolesPage /> },
      { path: 'policies', element: <GovProPoliciesPage /> },
      { path: 'procedures', element: <GovProProceduresPage /> },
      { path: 'directives', element: <GovProDirectivesPage /> },
      { path: 'standards', element: <GovProStandardsPage /> },
      { path: 'encadrement', element: <GovProEncadrementPage /> },
      { path: 'grc', element: <GovProGRCDashboardPage /> },
      { path: 'compliance', element: <GovProCompliancePage /> },
      { path: 'risk-register', element: <GovProRiskRegisterPage /> },
      { path: 'controls-audit', element: <GovProControlsAuditPage /> },
      { path: 'authority', element: <GovProAuthorityRegisterPage /> },
      { path: 'ai-impact', element: <GovProAIImpactPage /> },
      { path: 'strategic-analysis', element: <GovProStrategicAnalysisPage /> },
      { path: 'maturity-bridge', element: <GovProMaturityBridgePage /> },
      { path: 'benchmarks', element: <GovProBenchmarkPage /> },
      { path: 'alignment', element: <GovProAlignmentPage /> },
      { path: 'programs/data', element: <GovProDataProgramPage /> },
      { path: 'programs/ai', element: <GovProAIProgramPage /> },
      { path: 'programs/cloud', element: <GovProCloudProgramPage /> },
      { path: 'culture', element: <GovProCulturePage /> },
      { path: 'roadmap', element: <GovProRoadmapPage /> },
      { path: 'targets', element: <GovProTargetsPage /> },
      { path: 'processes', element: <GovProProcessesPage /> },
      { path: 'ops-governance', element: <GovProOpsGovernancePage /> },
      { path: 'risk-profile', element: <GovProRiskProfilePage /> },
      { path: 'reports', element: <GovProReportsPage /> },
      { path: 'templates', element: <GovProTemplatesPage /> },
      { path: 'integration', element: <GovProIntegrationPage /> },
      { path: 'audit-trail', element: <GovProAuditTrailPage /> },
      { path: 'settings', element: <GovProSettingsPage /> },
      { path: 'outils', element: <GovProOutilsPage /> },
      // Profile-MD route aliases (map to nearest functional page)
      { path: 'diagnostic', element: <GovProCockpitPage /> },
      { path: 'comites/new', element: <GovProRolesPage /> },
      { path: 'interviews/log', element: <GovProWizardPage /> },
      { path: 'policies/new', element: <GovProPoliciesPage /> },
      { path: 'raci/new', element: <GovProOperatingModelPage /> },
      { path: 'target-model', element: <GovProTargetsPage /> },
      { path: 'issues', element: <GovProIssueRegistryPage /> },
      { path: 'issues/:id', element: <GovProIssueDetailPage /> },
      { path: 'policies/:id', element: <GovProPolicyDetailPage /> },
      { path: 'procedures/:id', element: <GovProProcedureDetailPage /> },
      { path: 'standards/:id', element: <GovProStandardDetailPage /> },
      { path: 'risk-register/:id', element: <GovProRiskRegisterDetailPage /> },

      // Wave21: Newly registered (previously orphaned) pages
      { path: 'board-report', element: <GovProBoardReportPage /> },
      { path: 'business-continuity', element: <GovProBusinessContinuityPage /> },
      { path: 'contract-lifecycle', element: <GovProContractLifecyclePage /> },
      { path: 'exception-management', element: <GovProExceptionManagementPage /> },
      { path: 'executive-summary', element: <GovProGrcExecutiveSummaryPage /> },
      { path: 'reporting-center', element: <GovProGrcReportingCenterPage /> },
      { path: 'integrated-risk', element: <GovProIntegratedRiskAggregatePage /> },
      { path: 'integration-hub', element: <GovProIntegrationHubPage /> },
      { path: 'issue-management', element: <GovProIssueManagementPage /> },
      { path: 'policy-exception', element: <GovProPolicyExceptionPage /> },
      { path: 'policy-lifecycle', element: <GovProPolicyLifecyclePage /> },
      { path: 'regulatory-exam', element: <GovProRegulatoryExamPage /> },
      { path: 'resilience', element: <GovProResiliencePage /> },
      { path: 'resilience-testing', element: <GovProResilienceTestingPage /> },
      { path: 'stakeholder-portal', element: <GovProStakeholderTaskPortalPage /> },
      { path: 'unified-incident', element: <GovProUnifiedIncidentPage /> },
      { path: 'workflow-hub', element: <GovProWorkflowHubPage /> },
      { path: 'objectives', element: <GovProObjectivesPage /> },
    ],
  },
]
